import clsx from 'clsx'
import { PaperclipAttachment } from '@/assets/icons'
import { Tag } from '@/components/tag/Tag'
import { formatAttachmentCountLabel } from '@/user_files/utils/group-extracted-files'

export type EmailAttachmentCountProps = {
  count: number
  className?: string
}

/** Number + paperclip for an email's extracted attachment count, inline before the disclosure. */
export function EmailAttachmentCount({ count, className }: EmailAttachmentCountProps) {
  const label = formatAttachmentCountLabel(count)
  if (!label) return null

  return (
    <span className={clsx('inline-flex shrink-0 items-center', className)} title={label} aria-label={label}>
      <Tag variant="tonal" color="Neutral" size="xs" textCase="normal" shape="pill">
        <span aria-hidden="true">{count}</span>
        <PaperclipAttachment className="size-3 shrink-0" aria-hidden />
      </Tag>
    </span>
  )
}
